module.exports = __webpack_public_path__ + "img/ueex-app-store.0f65a1bf.png";